module.exports = function getResource(label, vars = []) {
    let resources = {
        modalTitle: 'Please sign in to Sephora',
        termsOfUseLink: 'Terms of Use',
        privacyPolicyLink: 'Privacy Policy'
    };

    return resources[label];
};
